import API from '@/org-app/api';
import {
  GET_EXTERNAL_COUNTRIES_AND_CATEGORIES,
  GET_EXTERNAL_SEGMENTS,
} from '@/org-app/store/modules/externalSegments/mutation-types';
import { createApiAction, createGetAllAction } from '@/utils/ActionsUtils';

export default {
  getExternalSegments: createGetAllAction(
    API.instance.getAllExternalSegments,
    GET_EXTERNAL_SEGMENTS,
    'messages.failedToGetAudienceFile',
  ),
  getExternalSegmentsByOrg: createGetAllAction(
    API.instance.getExternalAudienceSegmentsByOrg,
    null,
    'messages.failedToGetAudienceFile',
  ),
  getExternalCountriesAndCategories: createApiAction(
    API.instance.getExternalCountriesAndCategoriesByOrg,
    GET_EXTERNAL_COUNTRIES_AND_CATEGORIES,
    'messages.failedToGetAudienceFile',
  ),
};
